import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import api from "../../services/api";
import BackdropLoading from "../../components/BackdropLoading";

// SSO Brainess: recebe ?token=<jwt curto> vindo do ERP (edge function crm-sso),
// troca por uma sessão do Whaticket e entra. Full reload após salvar o token
// para o AuthProvider reinicializar já autenticado.
const Sso = () => {
  const location = useLocation();
  const [error, setError] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    // Token vem no fragment (#token=...) — não vaza em Referer/logs. Fallback
    // p/ a query (?token=) mantém compat durante o rollout do crm-sso novo.
    const hashParams = new URLSearchParams(
      (location.hash || "").replace(/^#/, ""),
    );
    const token = hashParams.get("token") || params.get("token");
    // embed=1 → modo sem sidebar (abas do ERP). sessionStorage é por-iframe: a
    // aba "Administrador" (embed ausente) mostra o Whaticket completo; as abas
    // embed=1 mostram só a tela-alvo.
    const embed = params.get("embed") === "1";

    // Destino pós-login. Whitelist p/ evitar open-redirect — só rotas internas
    // conhecidas. Sem `to`, o embed cai em /tickets (comportamento antigo).
    const allowedTargets = [
      "/tickets",
      "/crm-kanban",
      "/crm-tickets",
      "/crm-dashboard",
      "/sale-audit-dashboard",
      "/sale-audits",
      "/",
      "/connections",
      "/contacts",
      "/crm-calendar",
      "/crm-funnels",
    ];
    // A auditoria de uma conversa tem id na URL, então não cabe na lista de
    // rotas fixas. O padrão aceita só dígitos: nada de "//host", "..", query
    // ou qualquer coisa que vire redirecionamento externo.
    const allowedPatterns = [/^\/sale-audits\/\d+$/];

    const requestedTo = params.get("to");
    const isAllowed =
      !!requestedTo &&
      (allowedTargets.includes(requestedTo) ||
        allowedPatterns.some((re) => re.test(requestedTo)));
    const target = isAllowed ? requestedTo : embed ? "/tickets" : "/";

    if (!token) {
      setError("Token de acesso ausente.");
      return;
    }

    if (embed) {
      sessionStorage.setItem("whaticketEmbed", "1");
      // Guarda o destino da aba (ex.: /crm-kanban). Route.js e Dashboard usam
      // isto no lugar do "/tickets" fixo — assim, se o fluxo passar por um
      // redirect de "home" em embed, ele volta pra tela certa (não pra tickets).
      sessionStorage.setItem("whaticketHome", target);
    } else {
      sessionStorage.removeItem("whaticketEmbed");
      sessionStorage.removeItem("whaticketHome");
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/sso-brainess", { token });
        localStorage.setItem("token", JSON.stringify(data.token));
        api.defaults.headers.Authorization = `Bearer ${data.token}`;
        // Redireciona p/ o destino resolvido (whitelist): /tickets, /crm-kanban
        // ou "/" (Whaticket completo, quando não-embed). O `?v=` fura o cache
        // do documento: browsers com um index.html ANTIGO cacheado (pré
        // no-store) serviam o shell velho → bundle com hash inexistente →
        // fallback devolvia HTML como JS → tela branca no iframe. A query
        // única força buscar o index atual; React Router ignora a query.
        const cacheBust = `${target.includes("?") ? "&" : "?"}v=${Date.now()}`;
        window.location.replace(target + cacheBust);
      } catch (err) {
        setError(
          "Não foi possível entrar via SSO. Recarregue a página e tente novamente.",
        );
      }
    })();
  }, [location.search]);

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "sans-serif",
          color: "#888",
          padding: 24,
          textAlign: "center",
        }}
      >
        {error}
      </div>
    );
  }

  // Mesmo loader da app (BackdropLoading) → transição contínua até os tickets,
  // sem "flash" entre o SSO e o carregamento do Whaticket.
  return <BackdropLoading />;
};

export default Sso;
